import React, { useEffect } from 'react';
import Header from '../components/Header';
import { useLanguage } from '../context/LanguageContext';

const Datenschutz = () => {
  const { t } = useLanguage();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white">
      {/* Header */}
      <Header />

      {/* Content */}
      <main className="container mx-auto px-4 py-12 max-w-4xl pt-28">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8">Datenschutzerklärung</h1>
        
        <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">1. Datenschutz auf einen Blick</h2>
            <h3 className="text-lg font-medium text-gray-800 mt-6 mb-3">Allgemeine Hinweise</h3>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, 
              wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert 
              werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text 
              aufgeführten Datenschutzerklärung.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">2. Verantwortliche Stelle</h2>
            <p>
              Verantwortlich für die Datenverarbeitung auf dieser Website ist:
            </p>
            <p className="mt-4">
              <strong>Villa-Thailand.com</strong><br />
              Pran Mountain View<br />
              Moo 7, Pranburi 168/87<br />
              77120 Pranburi<br />
              Prachuap Khiri Khan<br />
              THAILAND
            </p>
            <p className="mt-4">
              <strong>Ansprechpartner:</strong> Marc Rosmann<br />
              <strong>Telefon:</strong> +49 162 199 1199<br />
              <strong>E-Mail:</strong> service@villa-thailand.com<br />
              <strong>Website:</strong> www.villa-thailand.com
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">3. Datenerfassung auf dieser Website</h2>
            <h3 className="text-lg font-medium text-gray-800 mt-6 mb-3">Wie erfassen wir Ihre Daten?</h3>
            <p>
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten 
              handeln, die Sie per E-Mail oder über ein Kontaktformular an uns senden.
            </p>
            <p className="mt-4">
              Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme 
              erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). 
              Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
            </p>

            <h3 className="text-lg font-medium text-gray-800 mt-6 mb-3">Wofür nutzen wir Ihre Daten?</h3>
            <p>
              Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten 
              können zur Analyse Ihres Nutzerverhaltens verwendet werden.
            </p>

            <h3 className="text-lg font-medium text-gray-800 mt-6 mb-3">Welche Rechte haben Sie bezüglich Ihrer Daten?</h3>
            <p>
              Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten 
              personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten 
              zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung 
              jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung 
              der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">4. Hosting</h2>
            <p>
              Diese Website wird bei einem externen Dienstleister gehostet (Hoster). Die personenbezogenen Daten, die auf 
              dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v.a. um 
              IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, 
              Websitezugriffe und sonstige Daten, die über eine Website generiert werden, handeln.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">5. Allgemeine Hinweise und Pflichtinformationen</h2>
            <h3 className="text-lg font-medium text-gray-800 mt-6 mb-3">Datenschutz</h3>
            <p>
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre 
              personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie 
              dieser Datenschutzerklärung.
            </p>
            <p className="mt-4">
              Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten 
              sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung 
              erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck 
              das geschieht.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">6. Cookies</h2>
            <p>
              Diese Website verwendet teilweise sogenannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an 
              und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer 
              zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.
            </p>
            <p className="mt-4">
              Die meisten der von uns verwendeten Cookies sind sogenannte „Session-Cookies". Sie werden nach Ende Ihres 
              Besuchs automatisch gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert bis Sie diese löschen. 
              Diese Cookies ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">7. Kontaktaufnahme</h2>
            <p>
              Wenn Sie uns per E-Mail oder Telefon kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden 
              personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und 
              verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">8. Externe Dienste</h2>
            <h3 className="text-lg font-medium text-gray-800 mt-6 mb-3">Google Maps</h3>
            <p>
              Diese Seite nutzt den Kartendienst Google Maps. Anbieter ist die Google Ireland Limited („Google"), 
              Gordon House, Barrow Street, Dublin 4, Irland. Zur Nutzung der Funktionen von Google Maps ist es notwendig, 
              Ihre IP-Adresse zu speichern. Diese Informationen werden in der Regel an einen Server von Google in den USA 
              übertragen und dort gespeichert.
            </p>
            
            <h3 className="text-lg font-medium text-gray-800 mt-6 mb-3">OpenWeatherMap</h3>
            <p>
              Für die Anzeige aktueller Wetterdaten nutzen wir den Dienst OpenWeatherMap. Dabei werden keine 
              personenbezogenen Daten an den Dienst übermittelt.
            </p>
          </section>

          <section className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              Stand: Januar 2026
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8 mt-16">
        <div className="container mx-auto px-4 text-center">
          <p className="text-gray-400">
            © 2026 Villa-Thailand.com . Alle Rechte vorbehalten.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Datenschutz;
